<template>
  <div class="card p-4" v-if="performanceFilterData.length > 0">
    <div class="card-header bg-transparent border-bottom">
      <h5 class="card-title mt-2 mb-3">Sales Performance</h5>
      <div class="row mb-4">
        <div class="col-4">
          <date-picker v-model="deliveryDates" range class="me-3" placeholder="Select Delivery Date"></date-picker>
        </div>
        <div class="col-4">
          <div class="input-group mb-3">
            <label class="input-group-text bg-primary text-white">Period</label>
            <select class="form-select"  @change="periodFilter($event)">
              <option value="" selected disabled></option>
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="input-group mb-3">
            <label class="input-group-text bg-primary text-white">Report Type</label>
            <select class="form-select " v-model="report_type">
              <option v-for="filter in performanceFilterData" :key="filter.id" :value="filter" class="multiselect-height-3">{{filter.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <multiselect v-if="report_type.id === 'categories'" class="" :multiple="true" v-model="report_ids" :options="report_type.options" :close-on-select="false" placeholder="Select one" label="name" track-by="name"></multiselect>
          <multiselect v-else-if="report_type.id === 'institutions'" class="" :multiple="true" v-model="report_ids" :options="report_type.options" :close-on-select="false" placeholder="Select one" label="name" track-by="name"></multiselect>
          <multiselect v-else-if="report_type.id === 'branches'" class="" :multiple="true" v-model="report_ids" :options="report_type.options" :close-on-select="false" placeholder="Select one" label="name" track-by="name"></multiselect>
          <multiselect v-else-if="report_type.id === 'products'" class="" :multiple="true" v-model="report_ids" :options="report_type.options" :close-on-select="false" placeholder="Select one" label="product_name" track-by="product_name"></multiselect>
        </div>

      </div>
      <div class="row mb-4">
        <div class="col-4">
          <div class="input-group mb-3">
            <label class="input-group-text bg-primary text-white">Filter Type</label>
            <select class="form-select " v-model="filter_type">
              <option v-for="filter in performanceFilterData" :key="filter.id" :value="filter">{{filter.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <multiselect v-if="filter_type.id === 'categories'" class="" :multiple="true" v-model="filter_ids" :options="filter_type.options" :close-on-select="false" placeholder="Select one" label="name" track-by="name"></multiselect>
          <multiselect v-else-if="filter_type.id === 'institutions'" class="" :multiple="true" v-model="filter_ids" :options="filter_type.options" :close-on-select="false" placeholder="Select one" label="name" track-by="name"></multiselect>
          <multiselect v-else-if="filter_type.id === 'branches'" class="" :multiple="true" v-model="filter_ids" :options="filter_type.options" :close-on-select="false" placeholder="Select one" label="name" track-by="name"></multiselect>
          <multiselect v-else-if="filter_type.id === 'products'" class="" :multiple="true" v-model="filter_ids" :options="filter_type.options" :close-on-select="false" placeholder="Select one" label="product_name" track-by="product_name"></multiselect>
        </div>
      </div>
      <div class="mt-3 align-middle">
        <div v-if="loading">
          <b-button variant="dark" size="lg" class="py-3 h3 w-50" disabled >
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Loading
          </b-button>
        </div>
        <div v-else>
          <b-button variant="dark" size="lg" class="py-3 h3 text-white w-50" @click="downloadSalesPerformanceData" v-if="period !== '' && deliveryDates !== '' && report_type.id !== ''">
            Fetch Report
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {mapActions} from "vuex";
import {HTTP} from "@/http";
import Multiselect from "vue-multiselect";

export default {
  name: "SalesPerformanceFilters",
  components: {
    Multiselect
  },
  props: {
    loading: {type: Boolean, default: false}
  },
  data(){
    return {
      performanceFilterData: [],
      deliveryDates: '',
      period: '',
      report_type: {
        id: '',
        options: []
      },
      filter_type: {
        id: '',
        options: []
      },
      report_ids: [],
      filter_ids: [],
    }
  },
  mounted() {
    this.fetchFilters();
  },
  methods:{
    ... mapActions({
      fetchSalesPerformanceFilters: 'http/fetchSalesPerformanceFilters',
    }),
    periodFilter(event){
      const value = event.target.value
      if(event.target.value !== ''){
        this.period = value
      }
    },
    async fetchFilters(){
      await HTTP.get(`app/reports/filtered-sales-performance/filters`)
          .then(response => {
            this.performanceFilterData = response.data.data
          })
    },
    async downloadSalesPerformanceData(){

      const start = moment(this.deliveryDates[0]).format('YYYY-MM-DD')
      const end = moment(this.deliveryDates[1]).format('YYYY-MM-DD')

      const r_id = []
      this.report_ids.forEach(object => {
        r_id.push(object.public_id)
      })

      const f_id = []
      this.filter_ids.forEach(object => {
        f_id.push(object.public_id)
      })

      const data = {'period': this.period, 'start': start, 'end': end, 'report_type': this.report_type.id, 'report_ids': r_id, 'filter_type': this.filter_type.id, 'filter_ids': f_id}
      this.$emit('downloadSalesPerformanceData', data)
    }
  }
}
</script>



<style scoped>

</style>
